// Zipping hundreds of files does not fit into a request, so all original files
// are zipped in the background and emailed as a download link instead.
// Call emailAttachmentsZip with a function that sends the request
export default {
  data() {
    return {
      zipRequested: false
    };
  },
  methods: {
    emailAttachmentsZip(sendRequest) {
      this.zipRequested = true;
      sendRequest().then(() => {
        this.$store.commit('ModalStore/setModal', {
          component: 'message-modal',
          width: 650,
          classes: ['sk-modal--new'],
          data: {
            title: this.$pgettext('translation', 'Your files are on the way'),
            text: `<p>${this.$pgettext('translation', 'We are packing all original files into one zip file and will email you a download link when it is ready. The link is valid for 4 hours.')}</p>`,
            context: this,
            showActions: false,
          }
        });
      }).catch(() => {
        this.zipRequested = false;
        this.$store.commit('ToastStore/setToast', {
          data: {
            position: 'bottom-center',
            message: this.$pgettext('translation', 'Could not prepare the files for download. Please try again.'),
            autoDeleteTime: 6000
          }
        });
      });
    }
  }
};
